'use client'
import { getCurrencySymbol } from '@l2p/apps-shared'
import { BonusCardDto } from '@l2p/profile-api'
import { useBalance } from '@l2p/swr-hooks'
import { useTranslations } from 'next-intl'
import React from 'react'
import { FixedButton } from '../../Buttons'
import Modal from '../../Modal'
import styles from './styles.module.scss'

const CancelBonusConfirmation: React.FC<{
  closeModal: () => void
  confirm: () => void
  bonus: BonusCardDto | null
  isLoading: boolean
  type: 'cancel' | 'activation'
}> = ({ closeModal, confirm, isLoading, bonus, type }) => {
  const t = useTranslations('translation')
  const { data } = useBalance()

  if (!data) return null

  return (
    <Modal
      width="400px"
      height="auto"
      portalNodeId="cancel-bonus"
      onClose={closeModal}
    >
      <div className={styles.container}>
        <div className={styles.title}>
          {type === 'cancel' ? (
            <div
              dangerouslySetInnerHTML={{
                __html: t.raw(`cancelBonusQuestion`),
              }}
            />
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: t.raw(`youHaveActiveBonus`),
              }}
            />
          )}
        </div>
        <div className={styles.bonusContainer}>
          <div>
            <div className={styles.bonusText}>
              {`${Number(data.totalAmount) - Number(data.amount)} ${
                data?.currency
              }`}
            </div>
            <div className={styles.bonusDescription}>{t('bonusAmount')}</div>
          </div>
          <hr className={styles.dividedLine} />
          <div>
            {bonus && (
              <div className={styles.bonusText}>
                {`${getCurrencySymbol(bonus?.currency)}${Number(
                  Number(bonus.startWageringBalance || 0) -
                    Number(bonus.wageringBalance || 0),
                ).toFixed(2)} / ${getCurrencySymbol(bonus?.currency)}${
                  bonus.startWageringBalance
                }`}
              </div>
            )}
            <div className={styles.bonusDescription}>{t('wageringStatus')}</div>
          </div>
        </div>
        <br />
        <div className={styles.description}>
          {type === 'cancel' ? (
            <div
              dangerouslySetInnerHTML={{
                __html: t.raw(`cancelBonusYouSure`),
              }}
            />
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: t.raw(`ifYouActiveBonusYouLoosePrev`),
              }}
            />
          )}
        </div>
        <div className={styles.buttonsContainer}>
          <FixedButton color="green" text="upper" onClick={closeModal}>
            {type === 'cancel' ? <> {t('saveBonus')}</> : <> {t('cancel')}</>}
          </FixedButton>
          <FixedButton
            color="red"
            text="upper"
            onClick={confirm}
            loading={isLoading}
          >
            {type === 'cancel' ? (
              <> {t('yesSure')}</>
            ) : (
              <> {t('yesChangeBonus')}</>
            )}
          </FixedButton>
        </div>
      </div>
    </Modal>
  )
}

export default CancelBonusConfirmation
